import { Box } from '@mui/material';
import styled from 'styled-components';

import { colors } from '@/globalStyles';

export const ShapeCardStyled = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-radius: 4px;
  border: 1px solid ${colors.transparent};
  cursor: pointer;

  &:hover {
    border: 1px solid ${colors.primary};
  }
`;
